import { useNavigateWithQuery } from '@shared/hooks/useNavigateWithQuery';
import { I18nStore } from '@tools/i18n/store';
import { RouteKey, ROUTES } from '@tools/routes';
import { injectTSDI } from '@tools/tsdi';
import { getLocaleFromBrowser } from '@tools/utils/locale';
import { observer } from 'mobx-react';
import * as React from 'react';

interface LocalizedPathRedirectProps {
    readonly page: RouteKey;
}

export const LocalizedPathRedirect = observer(
    ({ page }: LocalizedPathRedirectProps) => {
        const navigate = useNavigateWithQuery();
        const { setLocale } = injectTSDI(I18nStore);

        React.useEffect(() => {
            const { lang, countryCode } = getLocaleFromBrowser();

            setLocale({ lang, countryCode });

            const targetPath = ROUTES[page].path;
            const localizedPath = `/${countryCode.toLowerCase()}${targetPath !== '/' ? targetPath : ''}`;

            navigate(localizedPath, { replace: true });
        }, [navigate, page, setLocale]);

        return null;
    }
);
